import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @module
 *
 * @description Education Loans driver configurations
 */
import { getDisclaimer, getFixedAprAnnotation, getMaxFixedAPR, getMaxVariableAPR, getMinFICO, getMinFixedAPR, getMinVariableAPR, getVariableAprAnnotation } from '../selectors/education-loans';
import { getPercentageRange } from '../utils/format';
import { VALUE_SIZES } from '../constants/drivers';
/**
 * Get the min. credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. Credit Score',
    value: getMinFICO(offer),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the fixed APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */

export var getDriverFixedApr = function getDriverFixedApr(offer) {
  return {
    id: 'fixedAPR',
    label: 'Fixed APR',
    value: getPercentageRange(getMinFixedAPR(offer), getMaxFixedAPR(offer)),
    valueSize: VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: getDisclaimer(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverFixedAprWithAnnotation = function getDriverFixedAprWithAnnotation(offer) {
  return _objectSpread({}, getDriverFixedApr(offer), {
    UNSAFE_valueTooltip: getFixedAprAnnotation(offer)
  });
};
/**
 * Get the variable APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */

export var getDriverVariableApr = function getDriverVariableApr(offer) {
  return {
    id: 'variableAPR',
    label: 'Variable APR',
    value: getPercentageRange(getMinVariableAPR(offer), getMaxVariableAPR(offer)),
    valueSize: VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: getDisclaimer(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverVariableAprWithAnnotation = function getDriverVariableAprWithAnnotation(offer) {
  return _objectSpread({}, getDriverVariableApr(offer), {
    UNSAFE_valueTooltip: getVariableAprAnnotation(offer)
  });
};